var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentSectionLoader',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}]}),_vm._v(" "),_c('Transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}]},[_c('FormList',{attrs:{"loaded":_vm.loaded}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }